import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api, fmtErr, fmtDate } from "@/lib/api";
import { PageHead } from "@/components/desk/DeskLayout";
import { Button } from "@/components/ui/button";

export default function CommentsPage() {
  const [removed, setRemoved] = useState(false);
  const [rows, setRows] = useState([]);

  const load = () => api.get("/admin/comments", { params: { removed } }).then((r) => setRows(r.data));
  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [removed]);

  const remove = async (id) => {
    try {
      await api.delete(`/admin/comments/${id}`);
      toast.success("Comment removed");
      load();
    } catch (err) {
      toast.error(fmtErr(err));
    }
  };

  return (
    <div data-testid="comments-page">
      <PageHead title="Comments" sub="Comments appear instantly. Remove anything abusive." />
      <div className="flex gap-1 mb-4">
        {[[false, "Live"], [true, "Removed"]].map(([v, l]) => (
          <button key={l} data-testid={`comments-tab-${l.toLowerCase()}`} onClick={() => setRemoved(v)}
            className={`h-9 px-3 text-sm border rounded-sm ${removed === v ? "bg-zinc-900 text-white border-zinc-900" : "bg-white border-zinc-300"}`}>{l}</button>
        ))}
      </div>
      {rows.length === 0 && <p data-testid="comments-empty" className="bg-white border border-zinc-200 p-8 text-zinc-500">No comments.</p>}
      <ul className="space-y-2">
        {rows.map((c) => (
          <li key={c.id} data-testid={`admin-comment-${c.id}`} className="bg-white border border-zinc-200 p-4 flex gap-4 justify-between">
            <div className="min-w-0">
              <p className="text-sm"><span className="font-semibold">{c.user_name}</span> on{" "}
                <Link to={`/story/${c.story_slug}`} target="_blank" className="underline">{c.story_headline}</Link></p>
              <p className="mt-1 text-zinc-700 whitespace-pre-line break-words">{c.text}</p>
              <p className="mt-1 text-xs text-zinc-500 font-mono-meta">{fmtDate(c.created_at)}{c.removed && ` · removed by ${c.removed_by}`}</p>
            </div>
            {!c.removed && <Button size="sm" variant="outline" className="rounded-sm text-red-700 shrink-0" data-testid={`admin-comment-remove-${c.id}`} onClick={() => remove(c.id)}>Remove</Button>}
          </li>
        ))}
      </ul>
    </div>
  );
}
